var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('HeroSection'),_vm._v(" "),_c('CalculatorPickerSection'),_vm._v(" "),_c('BuildForSection'),_vm._v(" "),_c('HowToSection'),_vm._v(" "),_c('AboutSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }